export default __webpack_public_path__ + "static/oye-balthazaurus-scroll-4f77f9e2cbf0e94d8123a2d8635bd78b.gif";